import ACHDisbursementDetailsContainer from 'spa/containers/DisbursementDetails/ACH';
import InternationalWireContainer from 'spa/containers/DisbursementDetails/InternationalWire';

export {
  ACHDisbursementDetailsContainer,
  InternationalWireContainer as InternationalWireDisbursementDetailsContainer,
};
